import { useState } from "react";
import { Formik, Form, Field } from "formik";
// import { useAuth } from "../context/AuthContext";
import Toaster, { ToastContainerComponent } from "../components/Toaster";
import FullScreenLoader from "../components/FullScreenLoader";
import { useNavigate, Link } from "react-router-dom";
import { resetPasswordApi } from "../utils/api";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isSubmitting,setIsSubmitting] = useState(false)
  // Handle reset password
  const handleResetPassword = async (values) => {
    if (!values.otp || !values.newPassword || !values.confirmPassword) {
      Toaster.error("Please fill out all fields.");
      return;
    }

    if (values.newPassword !== values.confirmPassword) {
      Toaster.error("Passwords do not match.");
      return;
    }

    setLoading(true); // Show loader
    setIsSubmitting(true)
    try {
        console.log(values,"values===>")
      await resetPasswordApi(values.otp, values.newPassword,values.confirmPassword);
      sessionStorage.clear();
      Toaster.success("Password reset successful!");
      navigate("/signin");
    } catch (error) {
      Toaster.error("Failed to reset password. Please try again.");
    } finally {
      setLoading(false); // Hide loader after request
      setIsSubmitting(false)
    }
  };

  return (
    <>
      <FullScreenLoader loading={loading} />
      <div className="login_page">
        <ToastContainerComponent />
        
        <div className="login">
          <div className="login_left">
            <div className="login_box">
              <h2>Reset Password</h2>
              <Formik
                initialValues={{
                  otp: "",
                  newPassword: "",
                  confirmPassword: "",
                }}
                onSubmit={(values) => {
                  handleResetPassword(values);
                }}
              >
                
                  <Form className="login_form">
                    <div className="para_heading">
                    <p>
                        We've sent a 6-digit verification code to your email. Please enter
                        the code to log in.
                      </p>
                    </div>
                    <div className="input_field">
                    <Field
                        className="form_control"
                        type="text"
                        name="otp"
                        placeholder="Enter OTP"
                      />
                    </div>
                    <div className="input_field">
                      <Field
                        className="form_control"
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                      />
                      <span className="icon">
                        <i className="fa-solid fa-lock"></i>
                      </span>
                    </div>
                    <div className="input_field">
                      <Field
                        className="form_control"
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                      />
                      <span className="icon">
                        <i className="fa-solid fa-lock"></i>
                      </span>
                    </div>

                    <button
                      type="submit"
                      className="login_btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Resetting..." : "Reset Password"}
                    </button>
                  </Form>
                
              </Formik>
            </div>
          </div>
          <div className="login_right">
            <div className="logo">
              <img src="./images/logo.png" alt="Logo" />
            </div>
            <h2>
              Welcome! <br /> 1st Choice Formation
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword